import React from 'react';
import { EARLY } from '.';
import { StyledExemplarMainContentTitle } from '../components/Styled';
import { ExemplarCombined, TextTypes } from '../types';
import { Stage } from '../types/exemplars';

export const WORDS_AND_SENTENCES = 'Words and Sentences';
export const SENTENCES = 'Sentences';
export const WORDS = 'Words';

export const DEFAULT_EXEMPLAR_WIDTH = 926;
export const DEFAULT_EXEMPLAR_HEIGHT = 629;

export const DEFAULT_IMAGE_DIMENSIONS = {
  width: 0,
  height: 0,
  exemplarWidth: DEFAULT_EXEMPLAR_WIDTH,
  exemplarHeight: DEFAULT_EXEMPLAR_HEIGHT,
};

export const exemplarMainContentTitle = (exemplar: ExemplarCombined): JSX.Element => {
  const textType = <span>{exemplar?.text_type}</span>;
  if (exemplar && 'additional_text_types' in exemplar) {
    let additionalTitle = exemplar.additional_text_types?.join('');
    if (exemplar?.text_type === TextTypes.hybrid) {
      additionalTitle = exemplar.additional_text_types?.join(' / ');
    }

    return (
      <>
        {textType}
        <StyledExemplarMainContentTitle> &ndash; </StyledExemplarMainContentTitle>
        <StyledExemplarMainContentTitle bold>{additionalTitle}</StyledExemplarMainContentTitle>
      </>
    );
  }

  return textType;
};

interface IExemplarContentCSSProperties {
  lineHeight: string;
  fontSize: string;
  fontFamily: string;
}

interface IExemplarTitleCSSProperties {
  fontFamily: string;
  fontSize: string;
  lineHeight: string;
}

interface IExemplarCSSProperties {
  title: IExemplarTitleCSSProperties;
  content: IExemplarContentCSSProperties;
}

const defaultExemplarContentStyles: IExemplarCSSProperties = {
  title: {
    fontFamily: 'Mulish',
    fontSize: '30px',
    lineHeight: '38px',
  },
  content: {
    lineHeight: '27px',
    fontSize: '19.5px',
    fontFamily: 'Mulish',
  },
};

const consolidatingExemplarContentStyles: IExemplarCSSProperties = {
  title: {
    fontFamily: 'Merriweather-Sans',
    fontSize: '26px',
    lineHeight: '36px',
  },
  content: {
    lineHeight: '25px',
    fontSize: '17px',
    fontFamily: 'Merriweather',
  },
};

const developingExemplarContentStyles: IExemplarCSSProperties = {
  ...defaultExemplarContentStyles,
  title: {
    ...defaultExemplarContentStyles.title,
    fontSize: '28px',
    lineHeight: '36px',
  },
};

const extendingExemplarContentStyles: IExemplarCSSProperties = {
  ...consolidatingExemplarContentStyles,
  content: {
    ...consolidatingExemplarContentStyles.content,
    fontSize: '15px',
    lineHeight: '23px',
  },
};

export const exemplarCSSProperties = (stage?: string): IExemplarCSSProperties => {
  const styles: Record<string, IExemplarCSSProperties> = {
    emergent: defaultExemplarContentStyles,
    early: defaultExemplarContentStyles,
    developing: developingExemplarContentStyles,
    consolidating: consolidatingExemplarContentStyles,
    extending: extendingExemplarContentStyles,
  };

  return styles[stage === undefined ? EARLY : (stage.toLowerCase() as Stage)];
};

export const exemplarContentStyles = (stage?: string): string => {
  const contentCSSProperties = exemplarCSSProperties(stage).content;

  return `
    font-size: ${contentCSSProperties.fontSize};
    line-height: ${contentCSSProperties.lineHeight};
    font-family: '${contentCSSProperties.fontFamily}';
  `;
};

export const exemplarTitleStyles = (stage?: string): string => {
  const titleCSSProperties = exemplarCSSProperties(stage).title;

  return `
    font-size: ${titleCSSProperties.fontSize};
    line-height: ${titleCSSProperties.lineHeight};
    font-family: '${titleCSSProperties.fontFamily}';
  `;
};
